<template>
    <el-popover
        :placement="placement"
        :title="title"
        :width="width"
        :trigger="trigger"
        :index="index"
        :handleBlur="handleBlur"
    >
        <div class="input_popover_wrap">
            <el-input placeholder="Price" size="small" type="number" v-model="price" @blur="handleBlur('price', price, index)">
                <template slot="prepend">Price $</template >
            </el-input>

            <el-input placeholder="MSRP Price" size="small" type="number" v-model="mspr" @blur="handleBlur('mspr', mspr, index)">
                <template slot="prepend">MSRP $</template >
            </el-input>
        </div>
        <slot slot="reference">
            <span>price</span>
        </slot>
    </el-popover>
</template>

<script>
export default {
    data() {
        return {
        };
    },
    props: {
        placement: {
            type: String,
            default: "top",
        },
        title: {
            type: String,
            default: "Title",
        },
        width: {
            type: Number,
            default: 200,
        },
        trigger: {
            type: String,
            default: "click",
        },
        index: {
            type: Number,
            default: 0,
        },
        row: {
            type: Object,
            default: {},
        },
        price: {
            type: String,
            default: '',
        },
        mspr: {
            type: String,
            default: '',
        },
        handleBlur: {
          type: Function,
          default: () => {}
        }
    },
    methods: {
        // handleBlur() {
        //     this.$emit("handleInputBlur", {
        //         row: this.row,
        //         index: this.index,
        //         value,
        //     });
        // },
    },
};
</script>

<style lang="scss">
.input_popover_wrap {
    display: flex;
    justify-content: space-around;
    .el-input {
        .el-input-group__prepend {
            padding: 0 10px;
            border-radius: 0;
        }
        .el-input__inner {
            padding: 0 5px;
        }

        &+.el-input {
            margin-left: 10px;
        }
    }
}
</style>